/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_undo': {
    width: 28,
    height: 27,
    viewBox: '0 0 28 27',
    data: '<path pid="0" d="M12.5 10.5l2-8-8.5 8 8.5 9-2-9zm0 0h7a8 8 0 1 1 0 16H.5" stroke-miterlimit="16"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_undo.js